<template>
<i
  :class="['common-iconfont', 'common-iconfont-' + type ]"
  :style="{ 'fontSize': size + 'px', 'color': color }"
>
</i>
</template>

<script>
export default {
  props: {
    type: {
      type: String,
      required: true,
    },
    size: {
      type: [String, Number],
      default: '12px',
    },
    color: {
      type: String,
    },
  },
};
</script>

<style lang="scss">
@import '../assets/styles/_variable';

.common-iconfont {
  color: $mainColor;
}
</style>

